export default "__VITE_ASSET__CwAYN0m8__ 400w, __VITE_ASSET__HrYLKQAI__ 800w, __VITE_ASSET__9t0Otf5c__ 1280w";